import { useState } from 'react';
import '../../styles.css';
import { t } from '@avalara/bat-apps-shared/i18n';
import { SSelect } from '@avalara/skylab-sdk/react';
import type { Analytics, Connector } from '@avalara/types/index';
import type { History } from 'history';
import ConnectorInfo from './connector-info';
import ConnectorSearch from './connector-search';
import SohoInfo from './soho-info';

type Props = {
  analytics?: Analytics;
  connectors: Array<Connector>;
  myConnectors: Array<Connector>;
  gridView: Array<Connector>;
  inIntegrations: boolean;
  inArchetypeApp?: boolean;
  isEligibleToBuy: boolean;
  isFreeTrialCustomer?: boolean;
  isMobile: boolean;
  isSoho: boolean;
  hideConnectorSearch?: boolean;
  onSearchConnectors: (results: Array<Connector>, searchString: string) => void;
  onShowConnectorDetails: (arg0: Connector) => void;
  onDeselectConnector: () => void;
  onSelectConnector: (arg0: History<unknown> | null | undefined) => void;
  searchConnectorsResults: Array<Connector>;
  searchString: string;
  selectedConnector: Connector | null;
  toggleFooter?: () => void;
  fallbackImg: string;
  avataxLink: string;
};

const ConnectorSelector = (props: Props) => {
  const [showOtherDetails, setShowOtherDetails] = useState(false);
  const [activeSearch, setActiveSearch] = useState(false);

  const onShowOtherDetails = (showDetails: boolean) => {
    setShowOtherDetails(showDetails);
    setActiveSearch(false);
    if (showOtherDetails) props.onDeselectConnector();
  };

  const onTrackClickedLink = (event: string) => {
    props.analytics?.track(event);
  };
  const {
    connectors,
    myConnectors,
    gridView,
    inIntegrations,
    inArchetypeApp,
    isEligibleToBuy,
    isFreeTrialCustomer,
    isMobile,
    isSoho,
    hideConnectorSearch,
    onSearchConnectors,
    onShowConnectorDetails,
    onSelectConnector,
    searchConnectorsResults,
    searchString,
    selectedConnector,
    toggleFooter,
    fallbackImg,
    avataxLink,
  } = props;

  const apiConnector = gridView.find((c) => c.id === 'a0n4000000ChMxlAAF');
  const connectorsWithoutExtractors = connectors.filter((connector) => !connector.isExtractor);
  return (
    <div className={'content-container-two-col'}>
      <div className='grid-columns'>
        <h2 className='clear'>
          {inIntegrations ? 'Add' : 'Choose'} {t('shared.headings.from-our-most-popular-integrations')}
        </h2>
        <p>{t('shared.general.connectors-create-a-two-way-connection-avalara-receives-data')}</p>
        <div className='connector-grid'>
          <SSelect
            inputId='connector-select'
            placeholder={t('shared.placeholders.find-your-platform')}
            selectionOptional
            optionsList={gridView.map((c) => ({
              label: c.name,
              value: c.id,
              selected: c.id === selectedConnector?.id,
            }))}
            onS-select={(e) => {
              const connector = gridView.find((c) => c.id === e.detail.item.value);
              if (connector) onShowConnectorDetails(connector);
            }}
          />
        </div>
        <ConnectorInfo
          apiConnector={apiConnector}
          myConnectors={myConnectors}
          inIntegrations={inIntegrations}
          inArchetypeApp={inArchetypeApp}
          isEligibleToBuy={isEligibleToBuy}
          isFreeTrialCustomer={isFreeTrialCustomer}
          isMobile={isMobile}
          onShowConnectorDetails={onShowConnectorDetails}
          onSelectConnector={onSelectConnector}
          selectedConnector={selectedConnector}
          toggleFooter={toggleFooter}
          fallbackImg={fallbackImg}
          showOtherDetails={showOtherDetails}
          avataxLink={avataxLink}
          onTrackClickedLink={onTrackClickedLink}
        />
      </div>
      <div />
      {isSoho ? (
        <SohoInfo />
      ) : hideConnectorSearch ? null : (
        <ConnectorSearch
          connectors={connectorsWithoutExtractors}
          selectedConnector={selectedConnector}
          onShowConnectorDetails={onShowConnectorDetails}
          onSearchConnectors={onSearchConnectors}
          searchConnectorsResults={searchConnectorsResults}
          searchString={searchString}
          fallbackImg={fallbackImg}
          onShowOtherDetails={onShowOtherDetails}
          onActiveSearch={setActiveSearch}
          activeSearch={activeSearch}
        />
      )}
    </div>
  );
};

export default ConnectorSelector;
